import { RecursiveArg } from '@utils/types';

export const splitNotPrecededBy = (str: string, splitter: string, notPrecededBy: string) => {
  const regex = new RegExp(`([^${notPrecededBy}])(${splitter})`);
  const splittedText = str.split(regex);
  return splittedText.reduce((accum, value, i) => {
    const nextValue = splittedText[i + 1] as string;

    if (nextValue && value !== '.' && nextValue !== '.') {
      accum.push(value + nextValue);
    } else if (!nextValue && value !== '.') {
      accum.push(value);
    }
    return accum;
  }, [] as string[]);
};

const setPathToObject = (obj: RecursiveArg, path: string | string[], value: unknown) => {
  let arr;
  let key;
  if (!obj || typeof obj !== 'object') {
    obj = {};
  }
  const pathList = typeof path === 'string' ? splitNotPrecededBy(path, '\\.', '\\\\') : path;
  if (Array.isArray(pathList) && path.length > 0) {
    arr = pathList;
    [key] = arr;
    if (arr.length > 1) {
      arr.shift();
      obj[key.replace(/\\/g, '')] = setPathToObject(obj[key], arr, value);
    } else {
      obj[key.replace(/\\/g, '')] = value;
    }
  }
  return obj;
};

export default setPathToObject;
